Mmg.addShortcode(

  /**
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in
   * the DOM
   * @param {callable} callback The callback function applied to every element
   * matching the selector
   */
  'school_reviews',
  '.sc-school-reviews',

  /**
   *
   * Shortcode callback
   *
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in
   * data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching
   * the selector
   * @param {string} selector The shortcode selector passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {

    // Widget Declarations
    const $widget = $(el);
    const $reviews = $widget.find(`${selector}__reviews`);
    const $viewAll = $widget.find(`${selector}__view-all`);
    const $showLess = $widget.find(`${selector}__show-less`);
    const template = $widget.find(`${selector}__review-template`).html();

    (function init() {
      $showLess.hide();
      addEvents();
    })();


    /**
     * Add click listeners
     */
    function addEvents() {
      $viewAll.on('click', onViewAllClick);
      $showLess.on('click', onShowLessClick);
    }


    /**
     * Expand to every review for this school.
     * @param {*} event
     */
    function onViewAllClick(event) {
      event.preventDefault();
      fetchReviews({ school_id: model.school_id }, $viewAll, $showLess);
    }


    /**
     * Collapse back to the initial, server-rendered page size by re-querying.
     *
     * @param {*} event
     */
    function onShowLessClick(event) {
      event.preventDefault();
      fetchReviews({ school_id: model.school_id, max: model.max }, $showLess, $viewAll);
    }


    /**
     * Fetch reviews and replace the rendered list.
     *
     * @param {object} params
     * @param {jQuery} $trigger The button that was clicked.
     * @param {jQuery} $reveal The counterpart button to reveal on success.
     */
    function fetchReviews(params, $trigger, $reveal) {
      $trigger.hide();

      $.ajax({
        url: model.rest_url,
        method: 'GET',
        data: params,
      })
      .done(function(response) {
        const reviews = response.reviews || [];
        $reviews.html(reviews.map(renderReview).join(''));
        $reveal.show();
      })
      .fail(function() {
        $trigger.show();
      });
    }


    /**
     * Render a review using the embedded Mustache template.
     *
     * @param {object} review
     * @return {string}
     */
    function renderReview(review) {
      return Mustache.render(
        template,
        $.extend({
          _block: className,
        }, review)
      );
    }

  });
